<template>
    <div>
        <v-container>
            <v-layout align-center justify-center>
                <v-flex xs12 sm12 md12 lg8 xl6 style="text-align: center;">
                    <v-card class="elevation-1 pa-3" v-show="show=='meta'">
                        <v-card-text style="text-align: center">
                            <h3>{{$t("lang.exercise.questionInStore")}}</h3>
                            <v-form ref="form" @keyup.enter.native="onSave">
                                <v-layout>
                                    <!--v-flex>
                                        <v-select append-icon="supervised_user_circle"
                                                  v-validate="'required'"
                                                  :label="$t('lang.exercise.term')"
                                                  height="40px"
                                                  :items="terms"
                                                  item-text="term_name"
                                                  item-value="term_id"
                                                  chips
                                                  v-model="exercise.term"
                                                  :data-vv-as="$t('lang.exercise.term')"
                                                  name="term"
                                                  @change="loadExamType"
                                                  :error-messages="errors.first('term')"/>
                                    </v-flex-->
                                    <v-flex xs12 sm12 md12 lg12 xl12 style="margin-left: 5px">
                                        <v-select v-validate="'required'"
                                                  :label="$t('lang.exercise.examType')"
                                                  height="40px"
                                                  :items="examTypes"
                                                  item-text="exam_type_name"
                                                  item-value="exam_type_id"
                                                  chips
                                                  v-model="exercise.examType"
                                                  :data-vv-as="$t('lang.exercise.examType')"
                                                  name="examType"
                                                  @change="onchangeExamType"
                                                  :error-messages="errors.first('examType')"/>

                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="exercise.examType==7">
                                    <!--v-flex>
                                        <v-select append-icon="supervised_user_circle"
                                                  v-validate="'required'"
                                                  :label="$t('lang.exercise.term')"
                                                  height="40px"
                                                  :items="terms"
                                                  item-text="term_name"
                                                  item-value="term_id"
                                                  chips
                                                  v-model="exercise.term"
                                                  :data-vv-as="$t('lang.exercise.term')"
                                                  name="term"
                                                  @change="loadExamType"
                                                  :error-messages="errors.first('term')"/>
                                    </v-flex-->
                                    <v-flex xs12 sm12 md12 lg12 xl12 style="margin-left: 5px">
                                        <v-select v-validate="'required'"
                                                  label="Nguồn đề"
                                                  height="40px"
                                                  :items="examSource"
                                                  item-text="source_name"
                                                  item-value="id"
                                                  v-model="exercise.sourceId"
                                                  data-vv-as="Nguồn đề"
                                                  name="examSource"
                                                  key="examSource"
                                                  @change="onchangeExamType"
                                                  :error-messages="errors.first('examSource')"/>

                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="exercise.examType==7">
                                    <v-flex xs12 sm12 md12 lg12 xl12>
                                        <v-select label="Năm"
                                                  height="40px"
                                                  :items="years"
                                                  item-text="title"
                                                  item-value="year"
                                                  v-model="exercise.year"
                                                  data-vv-as="Năm"
                                                  name="year"
                                                  @change="getExamId(false)"
                                                  :error-messages="errors.first('year')"/>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="exercise.examType!=7">
                                    <v-flex xs12 sm12 md12 lg12 xl12>
                                        <div style="font-weight: bold;margin: 10px;text-align: left;margin: 10px 0px">
                                            Nội dung kiểm tra
                                        </div>
                                        <v-select v-validate="'required'"
                                                  :label="$t('lang.exercise.chapter')"
                                                  height="40px"
                                                  :items="chapters"
                                                  item-text="chapter"
                                                  item-value="chapter_id"
                                                  chips
                                                  :multiple="multiChapter"
                                                  v-model="exercise.chapter"
                                                  :data-vv-as="$t('lang.exercise.chapter')"
                                                  name="chapter"
                                                  @change="loadLesson"
                                                  :error-messages="errors.first('chapter')"/>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm12 md12 lg12 xl12>
                                        <v-select :label="$t('lang.exercise.lesson')"
                                                  v-if="showLesson == true"
                                                  height="40px"
                                                  :items="lessons"
                                                  item-text="lesson"
                                                  item-value="lesson_id"
                                                  v-model="exercise.lesson"
                                                  :data-vv-as="$t('lang.exercise.lesson')"
                                                  name="lesson"
                                                  @change="getExamId(false)"
                                                  :error-messages="errors.first('lesson')"/>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <div class="tableHeader">Danh sách đề từ kho đề</div>
                                        <v-data-table class="elevation-1"
                                                      :headers="examsHeaders"
                                                      :items="exams">
                                            <template slot="items" slot-scope="props">
                                                <td class="text-xs-left">{{ props.index+1}}</td>
                                                <td class="text-xs-left">{{ props.item["exam_name"]}}</td>
                                                <td class="text-xs-left">{{ props.item["number_of_question"]}}</td>
                                                <td class="text-xs-left">
                                                    <v-btn small fab color="primary"
                                                           @click="previewExam(props.item['exam_id'])">
                                                        <v-icon>visibility</v-icon>
                                                    </v-btn>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" @click="cancel">
                                {{ $t('lang.common.back') }}
                            </v-btn>
                            <v-btn class="yoprimary" dark @click="getExamId(false)">
                                Tìm kiếm từ kho đề
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-card class="elevation-1 pa-3" v-show="show=='detail'">
                        <v-card-text style="text-align: center">
                            <YolearnQuestion :exam-id="examId" id="preViewYoClassQuestion" type="select"
                                             @cancel="show='meta'" @save="saveQuestion" @change="getExamId(true)"/>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import {message} from "../../services";
    import axios from "axios";
    import YolearnQuestion from "./YolearnQuestion";

    export default {
        name: "question-in-store",
        components: {YolearnQuestion},

        props: {
            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            }
        },
        data() {
            return {
                uploadAnswer: null,
                show: "meta",
                clazz: {},
                terms: [],
                examTypes: [],
                multiChapter: false,
                chapters: [],
                showLesson: false,
                lessons: [],
                eduFrames: [],
                examSource: [],
                exams: [],
                examId: null,
                examsHeaders: [
                    {
                        text: "STT",
                        align: "center",
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Tên đề",
                        align: "center",
                        sortable: false,
                        value: "subject"
                    },
                    {
                        text: "Số câu",
                        align: "center",
                        sortable: false,
                        value: "number_of_question"
                    },
                    {
                        text: "Xem đề",
                        align: "left",
                        sortable: false,
                        value: "content"
                    }
                ],
                question: [],
                years: null,
                exercise: {
                    name: "",
                    subject: "",
                    question: null,
                    dueDate: new Date(),
                    effectiveDate: new Date(),
                    questionTime: 30,
                    markScale: 10,
                    content: "",
                    numberOfQuiz: 0,
                    attachId: null,
                    attachType: null
                },
            };
        },

        watch: {},

        created() {
            axios.post(process.env.VUE_APP_API_URL + "/class/getClass?classId=" + this.classId).then(
                data => {
                    this.clazz = data;
                    this.loadExamSource();
                    this.loadChapter();
                    this.loadLesson();
                    this.years = [];
                    let now = new Date();
                    let year = now.getFullYear();
                    this.years.push(
                        {
                            'year': null,
                            'title': 'Tất cả'
                        }
                    );
                    for (let i = year; i >= 2015; i--) {
                        let ob = {
                            'year': i,
                            'title': i
                        }
                        this.years.push(ob);
                    }
                },
                error => {
                    //console.log(error);
                }
            );
            this.loadExamType();
        },

        computed: {},

        methods: {
            calculateShowLesson: function () {
                ////console.log("calculate showw");
                if (this.exercise.chapter == null || this.exercise.chapter == "") {
                    this.showLesson = false;
                } else {
                    this.showLesson = false;
                    if (this.exercise.examType != null) {
                        for (let i = 0; i < this.examTypes.length; i++) {
                            if (this.examTypes[i].exam_type_id == this.exercise.examType) {
                                let name = this.examTypes[i].exam_type_name.toLowerCase();
                                if (name.indexOf("kiểm tra 15 phút") < 0) {
                                    this.showLesson = false;
                                    this.exercise.lesson = null;
                                } else {
                                    this.showLesson = true;
                                }
                                break;
                            }
                        }
                    }
                }
            },

            onchangeExamType: function () {
                this.calculateMultiChapter();
                if (this.exercise.examType == 7) {
                    this.exercise.chapter = null;
                    this.exercise.lesson = null;
                } else {
                    this.exercise.sourceId = null;
                    this.exercise.year = null;

                }
                this.getExamId(false);
                ////console.log(this.exercise.examType);
            },

            calculateMultiChapter: function () {
                this.exercise.chapter = "";
                this.showLesson = false;
                if (this.exercise.examType != null) {
                    for (let i = 0; i < this.examTypes.length; i++) {
                        if (this.examTypes[i].exam_type_id == this.exercise.examType) {
                            let name = this.examTypes[i].exam_type_name.toLowerCase();
                            if (name.indexOf("kiểm tra học kỳ") < 0 && name.indexOf("đề thi thpt") < 0) {
                                this.multiChapter = false;
                                return false;
                            }
                            break;
                        }
                    }
                    this.multiChapter = true;
                } else {
                    this.multiChapter = false;
                }

            },

            addMathDocument: function (divId, content) {
                /*
                                let div = document.createElement("div");
                                div.setAttribute("id", divId);
                                let main = document.getElementById(parentId);
                                main.appendChild(div);
                */

                typeset(() => {
                    let math = document.getElementById(divId);
                    math.innerHTML = content;
                    return math;
                });

            },

            loadTerm: function () {
                //console.log(process.env.VUE_APP_YO_LEARN_API);
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/terms", {
                        headers: {
                            'Content-Type': null
                        }
                    }
                ).then(
                    data => {
                        //console.log(data);
                        this.terms = data.data;
                    },
                    error => {
                        //console.log(error);
                    }
                )
            },

            loadExamType: function () {
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/exam_type").then(
                    data => {
                        this.examTypes = data.data;
                    },
                    error => {
                        //console.log(error);
                    }
                )

            },

            loadChapter: function () {
                if (this.clazz == null) {
                    this.chapters = [];
                    return;
                }
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/eduFrame?class_block_id=" + this.clazz.classBlockId + "&subject_id=" + this.clazz.disciplineId).then(
                    data => {
                        this.chapters = data.data;
                        //console.log(this.chapters);
                    },
                    error => {
                        //console.log(error);
                    }
                )

            },

            loadExamSource: function () {
                if (this.clazz == null) {
                    this.chapters = [];
                    return;
                }
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/exam-source?token=yoclass").then(
                    data => {
                        this.examSource = data.data;
                    },
                    error => {
                        //console.log(error);
                    }
                )

            },

            loadLesson: function () {
                if (this.clazz == null) {
                    this.lessons = [];
                    return;
                }
                this.calculateShowLesson();
                ////console.log(this.showLesson);
                if (!this.showLesson) {
                    this.getExamId(false);
                    return;
                }
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/eduFrame?class_block_id=" + this.clazz.classBlockId + "&subject_id=" + this.clazz.disciplineId + "&chapter_id=" + this.exercise.chapter).then(
                    data => {
                        this.lessons = data.data;
                    },
                    error => {
                        //console.log(error);
                    }
                )
                this.getExamId(false);

            },

            getExamId: function (preview) {
                if (this.clazz == null) {
                    this.lessons = [];
                    return;
                }
                //let url = process.env.VUE_APP_YO_LEARN_API + "/exam_id?token=yoclass&source=Yolearn";
                let url = process.env.VUE_APP_YO_LEARN_API + "/exam_list?token=yoclass";
                if (this.exercise.sourceId == undefined || this.exercise.sourceId == null || this.exercise.sourceId == "") {
                    url += "&source_id=Yolearn";
                } else {
                    url += "&source_id=" + this.exercise.sourceId;
                }
                let param = {};
                param["class_block_id"] = this.clazz.classBlockId;
                param["subject_id"] = this.clazz.disciplineId
                param["term_id"] = this.exercise.term;
                param["exam_type_id"] = this.exercise.examType;
                if (this.exercise.year != undefined && this.exercise.year != null && this.exercise.year != "") {
                    param["year"] = this.exercise.year;
                }
                if (this.exercise.chapter != null && this.exercise.chapter != undefined) {
                    param["chapter_id"] = this.exercise.chapter;
                }
                if (this.exercise.lesson != null && this.exercise.lesson != undefined) {
                    param["lesson_id"] = this.exercise.lesson;
                }
                //console.log(param);
                for (let key in param) {
                    if (param[key] != null) {
                        url += "&" + key + "=" + param[key];
                    }
                }
                axios.get(url).then(
                    data => {
                        this.exams = data.data;
                        if (this.exams == null || this.exams == "" || this.exams.length == 0) {
                            this.exams = [];
                            return;
                        } else {
                            if (preview) {
                                let rd = Math.floor(Math.random() * this.exams.length);
                                this.previewExam(this.exams[rd].exam_id);
                            }
                        }
                        //console.log(this.exams);
                    },
                    error => {
                        //console.log(error);
                    }
                )

            },

            previewExam: function (examId) {
                /*
                                this.show="detail";
                                this.examId = examId;
                */
                //
                //
                //
                let url = process.env.VUE_APP_YO_LEARN_API + "/exams/exam_detail?token=yoclass&exam_id=" + examId;
                axios.get(url).then(
                    data => {
                        this.saveQuestion(data);
                    },
                    error => {
                        //console.log(error);
                    }
                )

            },

            saveQuestion: function (examiniation) {
                this.$emit("save", examiniation);
                this.show = "meta";
            },

            cancel: function () {
                this.$emit("cancel");
            }
        }
    };
</script>

